import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribeStatus('success');
    setSubscribeMsg('订阅成功！感谢关注黑料网站。');
    setEmail('');
    setTimeout(() => setSubscribeStatus('idle'), 3000);
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-bold text-background-50">黑料网站</span>
            <p className="text-sm text-background-50/60 mt-3 leading-relaxed max-w-[280px]">
              国内领先的娱乐八卦资讯聚合平台，提供黑料网在线观看、吃瓜黑料在线、51黑料在线观看等热门服务，全天候追踪全网最劲爆的娱乐圈八卦与爆料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">热门话题</a>
              <a href="#cards" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">深度爆料</a>
              <a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">热度榜单</a>
              <a href="#media" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">黑料视频</a>
              <a href="#about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">关于我们</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40">合作伙伴信息即将上线</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">订阅更新</h4>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱订阅最新爆料"
                className="px-3 py-2.5 bg-background-50/10 border border-background-50/20 rounded-lg text-sm text-background-50 placeholder:text-background-50/40 outline-none focus:border-primary-500 transition-colors"
                required
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <button
                type="submit"
                className="px-4 py-2.5 bg-primary-600 hover:bg-primary-500 text-background-50 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                立即订阅
              </button>
              {subscribeStatus !== 'idle' && (
                <p className={`text-xs ${subscribeStatus === 'success' ? 'text-accent-400' : 'text-primary-400'}`}>
                  {subscribeMsg}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 黑料网站 版权所有。本站内容仅供娱乐参考，请以官方通报为准。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer no-underline">用户协议</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer no-underline">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer no-underline">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}